import * as yup from 'yup'

export default yup.object().shape({
  person: yup.object().shape({
    cnpj: yup.string().required('O campo CNPJ é requerido.'),
    business_name: yup.string().required('O campo Razão Social é requerido.')
  })
})
